import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { CartProvider } from './context/cart';
import { AuthProvider } from './context/auth';
import { QueryClient, QueryClientProvider } from 'react-query';
//Component
import { Provider } from "react-redux";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import { getAllProducts } from "./actions";
import "./index.css";
import App from "./App";
import { unregister } from "./registerServiceWorker";
import store from "./store";

const queryClient = new QueryClient();


ReactDOM.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <CartProvider>
          <App />
        </CartProvider>
      </AuthProvider>
    </QueryClientProvider>
  </Provider>,
  document.getElementById('root')
);


unregister();
